import React from 'react';
import { formatMoney } from '../../../../../utils/formating';

export default function LiveVoucherPreview({ liveVoucher }) {
  if (!liveVoucher || !liveVoucher.lines?.length) return null;

  return (
    <div className="card shadow-sm border-0 mb-3" style={{ backgroundColor: 'var(--color-gray-10)', borderColor: 'var(--color-gray-30)', color: 'var(--color-dark)' }}>
      <div className="card-body">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h5 className="card-title h6 fw-bold mb-0 text-primary">Vista Previa de Comprobante Consolidado</h5>
          <span className={`badge ${liveVoucher.balanced ? 'bg-success' : 'bg-danger'}`}>
            {liveVoucher.balanced ? '✓ Asiento Cuadrado' : '⚠️ Desbalanceado'}
          </span>
        </div>
        <div className="table-responsive">
          <table className="table table-hover table-sm align-middle small" style={{ color: 'inherit' }}>
            <thead>
              <tr className="border-bottom text-muted" style={{ borderColor: 'var(--color-gray-30)' }}>
                <th>Cuenta</th>
                <th>Descripción</th>
                <th className="text-end" style={{ width: '120px' }}>Débito</th>
                <th className="text-end" style={{ width: '120px' }}>Crédito</th>
              </tr>
            </thead>
            <tbody>
              {liveVoucher.lines.map((l, i) => (
                <tr key={i} className="border-bottom" style={{ borderColor: 'var(--color-gray-20)' }}>
                  <td>
                    <div className="fw-semibold text-info">{l.account_code}</div>
                    <div className="text-muted small">{l.account_name}</div>
                  </td>
                  <td>{l.description}</td>
                  <td className="text-end text-success">{l.debit > 0 ? formatMoney(l.debit) : '-'}</td>
                  <td className="text-end text-danger">{l.credit > 0 ? formatMoney(l.credit) : '-'}</td>
                </tr>
              ))}
            </tbody>
            <tfoot>
              <tr className="fw-bold border-top" style={{ borderColor: 'var(--color-gray-30)' }}>
                <td colSpan="2" className="text-end text-muted">TOTALES:</td>
                <td className="text-end text-success">{formatMoney(liveVoucher.totalDebit)}</td>
                <td className="text-end text-danger">{formatMoney(liveVoucher.totalCredit)}</td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </div>
  );
}
